import { useState, useEffect, useContext, useRef } from 'react';
import './join.css';
import { isRegistNum } from '../../utils/common';
import BANK_LIST from '../../dataset/nicepay';
import restapi from '../../utils/restapi';
import { PersonContext } from '../../context/PersonContext';
import { getJoinComment } from '../../utils/testing_teacher_document';

const TestingTeacherDocumentJoin = ({ testingTeacherDocumentObj = {}, onSave, onClose }) => {
  const { person } = useContext(PersonContext);

  console.log(testingTeacherDocumentObj);
  
  // registNum 안전하게 처리
  let registNum = ['', ''];
  
  const [registNum1, setRegistNum1] = useState(registNum[0] || '');
  const [registNum2, setRegistNum2] = useState(registNum[1] || '');
  const [isAgreed, setIsAgreed] = useState(testingTeacherDocumentObj?.isAgreed || false);
  const [isUseSignature, setIsUseSignature] = useState(person?.data?.isUseSignature || false);
  const [isAccountChecked, setIsAccountChecked] = useState(false);

  const signCanvasRef = useRef(null);
  const [signImage, setSignImage] = useState('');

  const bodyRef = useRef(null);

  // 서명 이미지 가져오기 함수
  const fetchSignature = async () => {
    if (person && person.person_id) {
      try {
        const res = await restapi.get_person_signature(person.person_id);
        console.log(res);
        if (res && res.signatureImage) {
          setSignImage(res.signatureImage);
        }
      } catch (e) {
        setSignImage('');
      }
    }
  };

  // 드로잉 훅 - 먼저 정의
  const useCanvasDraw = (canvasRef) => {
    useEffect(() => {
      const canvas = canvasRef.current;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      let drawing = false;

      // 실제 렌더링된 크기로 캔버스 크기 설정
      const rect = canvas.getBoundingClientRect();
      canvas.width = rect.width;
      canvas.height = rect.height;

      // 배경 흰색으로 채우기
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      const getPos = (e, canvas) => {
        const rect = canvas.getBoundingClientRect();
        let clientX, clientY;
        if (e.touches && e.touches.length > 0) {
          clientX = e.touches[0].clientX;
          clientY = e.touches[0].clientY;
        } else if (e.nativeEvent) {
          clientX = e.nativeEvent.clientX;
          clientY = e.nativeEvent.clientY;
        } else if (e.clientX !== undefined && e.clientY !== undefined) {
          clientX = e.clientX;
          clientY = e.clientY;
        } else {
          return { x: 0, y: 0 };
        }
        return {
          x: clientX - rect.left,
          y: clientY - rect.top
        };
      };

      const startDraw = (e) => {
        drawing = true;
        ctx.beginPath();
        const pos = getPos(e, canvas);
        ctx.moveTo(pos.x, pos.y);
        if (e.touches) e.preventDefault();
      };
      const draw = (e) => {
        if (!drawing) return;
        ctx.lineWidth = 2;
        ctx.lineCap = 'round';
        ctx.strokeStyle = '#000000';
        const pos = getPos(e, canvas);
        ctx.lineTo(pos.x, pos.y);
        ctx.stroke();
        if (e.touches) e.preventDefault();
      };
      const endDraw = (e) => {
        drawing = false;
        ctx.closePath();
        if (e && e.touches) e.preventDefault();
      };

      // PC
      canvas.addEventListener('mousedown', startDraw);
      canvas.addEventListener('mousemove', draw);
      canvas.addEventListener('mouseup', endDraw);
      canvas.addEventListener('mouseleave', endDraw);
      // 모바일
      canvas.addEventListener('touchstart', startDraw, { passive: false });
      canvas.addEventListener('touchmove', draw, { passive: false });
      canvas.addEventListener('touchend', endDraw, { passive: false });

      return () => {
        canvas.removeEventListener('mousedown', startDraw);
        canvas.removeEventListener('mousemove', draw);
        canvas.removeEventListener('mouseup', endDraw);
        canvas.removeEventListener('mouseleave', endDraw);
        canvas.removeEventListener('touchstart', startDraw);
        canvas.removeEventListener('touchmove', draw);
        canvas.removeEventListener('touchend', endDraw);
      };
    // eslint-disable-next-line
    }, [canvasRef]);
  };

  // useCanvasDraw 훅 사용 - 정의 후 호출
  useCanvasDraw(signCanvasRef);
  
  // isUseSignature가 true일 때 서명 이미지 가져오기
  useEffect(() => {
    if (isUseSignature) {
      fetchSignature();
    }
    // eslint-disable-next-line
  }, [isUseSignature, person]);

  // 캔버스에 이미지 그리기
  useEffect(() => {
    if (signImage && signCanvasRef.current) {
      const img = new window.Image();
      img.onload = () => {
        const canvas = signCanvasRef.current;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      };
      img.src = signImage;
    }
  // eslint-disable-next-line
  }, [signImage]);

  const clearCanvas = async () => {
    const canvas = signCanvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    setSignImage(''); // signImage도 초기화
  };

  // isUseSignature 체크박스 변경 핸들러
  const handleUseSignatureChange = (e) => {
    const checked = e.target.checked;
    setIsUseSignature(checked);
    
    if (checked) {
      // 체크되면 서명 이미지 가져오기
      fetchSignature();
    } else {
      // 체크 해제되면 캔버스 초기화
      const canvas = signCanvasRef.current;
      if (canvas) {
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        setSignImage('');
      }
    }
  };

  const [obj, setObj] = useState(testingTeacherDocumentObj);
  const [bank, setBank] = useState('');
  const [account, setAccount] = useState('');
  const [name, setName] = useState('');

  const handleSendAccountConfirm = async () => {
    setIsAccountChecked(false);
  
    try {  
      if (await restapi.isValidBankAccount(bank, account, name)) {
        alert('정상 계좌입니다.');
        setIsAccountChecked(true);
      } else {
        alert('계좌 정보가 일치하지 않습니다. 다시 확인해주세요.');
        setIsAccountChecked(false);
      }
    } catch (error) {
      console.error('계좌조회 오류:', error);
      alert('계좌를 찾을 수 없습니다. 계좌 확인 후 계좌조회 버튼을 눌러주세요.');
    }
  }
  
  // 캔버스가 비어있는지 확인하는 함수
  const isCanvasEmpty = (canvas) => {
    const ctx = canvas.getContext('2d');
    const pixelBuffer = new Uint32Array(
      ctx.getImageData(0, 0, canvas.width, canvas.height).data.buffer
    );
    return !pixelBuffer.some(color => color !== 0);
  };

  const handleSubmit = async () => {
    // testingTeacherDocumentObj가 없으면 저장 불가
    if (!testingTeacherDocumentObj?.testing_teacher_document_id) {
      alert('문서 정보가 없습니다.');
      return;
    }

    if (!isAccountChecked) {
      alert('계좌 조회를 먼저 진행해주세요.');
      return;
    }

    if (!registNum1 || registNum1.length !== 6) {
      alert('주민번호 앞 6자리를 입력해주세요.');
      return;
    }

    if (!registNum2 || registNum2.length !== 7) {
      alert('주민번호 뒷 7자리를 입력해주세요.');
      return;
    }

    if (!/^\d{6}$/.test(registNum1) || !/^\d{7}$/.test(registNum2)) {
      alert('주민번호 형식이 올바르지 않습니다. 앞 6자리와 뒷 7자리를 정확히 입력해주세요.');
      return;
    }

    if (!isRegistNum(`${registNum1}${registNum2}`)) {
      alert('주민번호 형식이 올바르지 않습니다. 다시 확인해 주세요.');
      return;
    }

    const signCanvas = signCanvasRef.current;
    
    // 캔버스가 비어있는지 확인
    if (!signCanvas || isCanvasEmpty(signCanvas)) {
      alert('서명을 작성해주세요.');
      return;
    }

    const signatureImage = signCanvas.toDataURL('image/png');
    
    // 추가로 빈 캔버스의 기본 데이터 URL과 비교
    const emptyCanvas = document.createElement('canvas');
    emptyCanvas.width = signCanvas.width;
    emptyCanvas.height = signCanvas.height;
    const emptyDataURL = emptyCanvas.toDataURL('image/png');
    
    if (signatureImage === emptyDataURL) {
      alert('서명을 작성해주세요.');
      return;
    }

    // isUseSignature가 true인 경우 서명 이미지 저장
    if (isUseSignature) {
      const signatureData = {
        data: JSON.stringify({
          isUseSignature: isUseSignature,
        }),
        signatureImage: signatureImage
      };
      try {
        await restapi.person_signature_update(person.person_id, signatureData);
      } catch (e) {
        alert('서명 저장 실패 : ' + e.message);
        return;
      }
    }

    try {
      const documentData = {
        testing_teacher_id: testingTeacherDocumentObj.testing_teacher_id,
        registNum: `${registNum1}-${registNum2}`,
        bank: bank,
        account: account,
        name: name,
        status: 2,
        comment: getJoinComment(person.name, person.birth, person.handphone, testingTeacherDocumentObj.testingTeacherObj.testingPlaceObj.name || '', testingTeacherDocumentObj.testingTeacherObj.type || 0, testingTeacherDocumentObj.testingTeacherObj.price || 0,  signatureImage),
      };
      
      const dataset = await restapi.testing_teacher_document_update(testingTeacherDocumentObj.testing_teacher_document_id, documentData);
      setObj(dataset);
      alert('감독관 서약서 및 영수증이 저장되었습니다.');
      onSave();
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  }

  useEffect(() => {
    const setBodyHeight = () => {
      if (bodyRef.current) {
        // 실제 브라우저 영역 높이에서 100px을 뺀 값 적용
        bodyRef.current.style.height = `${window.innerHeight - 100}px`;
      }
    };
    setBodyHeight();
    window.addEventListener('resize', setBodyHeight);
    return () => window.removeEventListener('resize', setBodyHeight);
  }, []);

  return (
    <div id="testing_teacher_document_join">
      <div className="head">
        <h1>서약서 및 영수증 작성하기</h1>
      </div>
      <div className="body" ref={bodyRef}>
        <h1>{obj?.title || '문서 제목'}</h1>
        <ul className="form">
          <li>
            <label>성명</label>
            <span>
              {obj?.testingTeacherObj?.personObj?.name || ''}
            </span>
          </li>
          <li>
            <label>주민번호</label>
            <span>
              <input
                type="text"
                placeholder="주민번호 앞 6자리"
                value={registNum1}
                maxLength={6}
                onChange={(e) => setRegistNum1(e.target.value)}
              /> - <input
                type="text"
                placeholder="주민번호 뒷 7자리"
                maxLength={7}
                value={registNum2}
                onChange={(e) => setRegistNum2(e.target.value)}
              />
            </span>
          </li>
          <li>
            <label>은행선택</label>
            <span>
              <select
                value={bank}
                onChange={(e) => setBank(e.target.value)}
              >
                <option value="">은행을 선택하세요.</option>
                {BANK_LIST.map(b => (
                  <option key={b.code} value={b.code}>{b.name}</option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>계좌번호</label>
            <span>
              <input
                type="text"
                placeholder="계좌번호를 입력하세요."
                value={account}
                onChange={(e) => setAccount(e.target.value)}
              />
            </span>
          </li>
          <li>
            <label>예금주</label>
            <span>
              <input
                type="text"
                placeholder="예금주를 입력하세요."
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="name"
              />
              <button onClick={handleSendAccountConfirm}>계좌조회</button>
            </span>
          </li>
          <li>
            <label>서명이미지<br/><button onClick={clearCanvas}>초기화</button></label>
            <span>
              <canvas id="signature-canvas" ref={signCanvasRef}></canvas>
              <div>
                <input 
                  type="checkbox" 
                  checked={isUseSignature} 
                  onChange={handleUseSignatureChange} 
                /> 다음에도 동일한 서명 사용
              </div>
            </span>
          </li>
          <li>
            <label>서명동의</label>
            <span>
              <div className="agreement_text">
                <p>위 감독위원으로 취임함에 있어 사단법인 한국국어능력평가협회 시험 규정에 따라 시험 관리와 감독 업무를 성실히 수행할 것을 서약합니다.</p>
              </div>
              <input
                id='isAgreed'
                type="checkbox"
                checked={isAgreed}
                onChange={(e) => setIsAgreed(e.target.checked)}
              /> <label htmlFor='isAgreed'>동의합니다.</label>
            </span>
          </li>
        </ul>
      </div>
      <div className="foot">
        <button onClick={handleSubmit} disabled={!isAgreed}>저장</button>
        <button onClick={onClose}>닫기</button>
      </div>
    </div>
  );
}

export default TestingTeacherDocumentJoin;